import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProject } from "../Model/ProposalProject";

export async function patchProposalProject(id, data) {
	let response = await getAPIResponse("/v1/proposal-project/"+id, data, "PATCH");
	if (response === null) {
		return null;
	}
	try {
		let proposalProject = ProposalProject.createFromResponseData(response);
		return proposalProject;
	} catch (error) {
		return null;
	}
}